module.exports = __webpack_public_path__ + "img/fav-dark.7042a855.png";